import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CustomTabs from '../../../../components/custom-tabs/CustomTabs';
import { USER_DETAIL_BROKER_CRM_TABS } from '../constants';

import Dashboard  from './broker/Dashboard';
import Properties from './broker/Properties';
import Clients    from './broker/Clients';
import Leads      from './broker/Leads';
import FollowUps  from './broker/FollowUps';

const BrokerCRM = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const activeTab = searchParams.get('broker-tabs') || 'dashboard';

    const { userDetail } = useSelector((state) => state.allUsers);

    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard':  return <Dashboard  userId={id} />;
            case 'properties': return <Properties userId={id} userDetail={userDetail} isLand={false} />;
            case 'lands':      return <Properties userId={id} userDetail={userDetail} isLand={true} />;
            case 'clients':    return <Clients    userId={id} userDetail={userDetail} />;
            case 'leads':      return <Leads      userId={id} />;
            case 'followups':  return <FollowUps  userId={id} />;
            default:           return null;
        }
    };

    return (
        <div className='profile-tab grid gap-3'>
            <div className='bg-white rounded-3 g-col-2 p-3 shadow-md h-fit-content'>
                <h5 className='mb-2 fw-bold' style={{ fontSize: '16px' }}>Broker CRM Sections</h5>
                <CustomTabs
                    accessor='broker-tabs'
                    className='flex-column gap-2'
                    linkClassName='w-100 text-start'
                    items={USER_DETAIL_BROKER_CRM_TABS}
                    defaultTab='dashboard'
                    variant='pills'
                />
            </div>

            <div className='bg-white rounded-3 g-col-10 p-4 shadow-md h-fit-content'>
                {renderContent()}
            </div>
        </div>
    );
};

export default BrokerCRM;
